import { contactCard } from '../../shared';

export const sellerCard = contactCard(
  'sellerSideContacts.sellerX',
  'counterpartyClient',
);
